var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { ImageList } from "../ImageList";
export class ImageViewer extends Component {
    constructor() {
        super('ImageViewer', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.component-image-viewer-interactiv-area').on('mousemove', (event) => {
                const caption = $('.component-image-viewer .caption');
                caption.css({
                    top: `calc(${event.layerY + 10}px + var(--header-height))`,
                    left: `${event.layerX + 10}px`,
                });
            }).on('mouseenter', () => {
                $('.component-image-viewer .caption').removeClass('d-lg-none');
            }).on('mouseleave', () => {
                $('.component-image-viewer .caption').addClass('d-lg-none');
            }).on('click', () => {
                ImageList.currentInstance.loadNextImage();
            });
            $('.component-image-viewer').on('click', () => {
                if ($(window).width() > 991)
                    return;
                $('.component-image-viewer img, .component-image-viewer .caption').remove();
                $('.component-image-viewer').addClass('d-none').removeClass('d-flex');
            });
            // On swipe left or right on the interactive area, we need to navigate to the next or previous image if there are multiple images
            let touchStartX = 0;
            let touchEndX = 0;
            $('.component-image-viewer-interactiv-area').on('touchstart', (event) => {
                touchStartX = event.changedTouches[0].screenX;
            });
            $('.component-image-viewer-interactiv-area').on('touchend', (event) => {
                touchEndX = event.changedTouches[0].screenX;
                if (touchEndX < touchStartX - 50) {
                    ImageList.currentInstance.loadNextImage();
                }
                else if (touchEndX > touchStartX + 50) {
                    ImageList.currentInstance.loadPreviousImage();
                }
            });
            $(window).on('resize', () => {
                ImageViewer.resize();
            });
            this.success();
        });
    }
    static resize() {
        const imageElement = $('.component-image-viewer img');
        const imageViewerAspectRatio = imageElement.width() / imageElement.height();
        $('.component-image-viewer-interactiv-area').css({
            width: (this.currentAspectRatio > imageViewerAspectRatio) ? '100%' : `${100 * this.currentAspectRatio / imageViewerAspectRatio}%`,
            height: (this.currentAspectRatio > imageViewerAspectRatio) ? `${100 / this.currentAspectRatio * imageViewerAspectRatio}%` : '100%',
        });
        $('.component-image-viewer-navigation').css({
            width: (this.currentAspectRatio > imageViewerAspectRatio) ? '100%' : `${100 * this.currentAspectRatio / imageViewerAspectRatio}%`,
        });
    }
}
ImageViewer.currentAspectRatio = 0;
